import React, { useState } from 'react'
import styled from 'styled-components'
import {
  Card as MuiCard,
  CardContent,
  Grid,
  LinearProgress,
  Menu,
  MenuItem,
  IconButton,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

import { DetailTable, FieldSpec } from 'src/components/Table'

interface Action {
  title: string
  onClick: () => void
  condition?: boolean
}

export interface MenuItem {
  Icon: React.FC<any>
  actions: Action[]
  condition?: boolean
}

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailComponentProps {
  obj: ObjInfo
  menuItems?: MenuItem[]
  fields: FieldSpec[]
  Icon: React.FC
  customFields?: Record<string, string>
}

const Card = styled(MuiCard)(spacing)
const Centered = styled.div`
  text-align: center;
`

export const DetailComponent = (props: DetailComponentProps) => {
  const { obj, menuItems = [], fields, Icon, customFields } = props

  const initial = menuItems.map(() => null)
  const [anchorEls, setAnchorEls] = useState<(null | HTMLElement)[]>(initial)
  const openFunc = (index: number) => {
    return (event: React.MouseEvent<HTMLButtonElement>) => {
      anchorEls[index] = event.currentTarget
      setAnchorEls([...anchorEls])
    }
  }
  const closeFunc = (index: number) => {
    return () => {
      anchorEls[index] = null
      setAnchorEls([...anchorEls])
    }
  }

  return (
    <Card mb={6}>
      <CardContent>
        <Centered>
          <Icon />
          <Typography variant="h6" gutterBottom>
            {!obj.isLoading && obj?.data?.name}
          </Typography>
          <Grid container justify="center" spacing={4}>
            {menuItems.map((item: MenuItem, index) => (
              <React.Fragment key={index}>
                {(item.condition === undefined || item.condition) && (
                  <Grid item>
                    <IconButton size="small" onClick={openFunc(index)}>
                      <item.Icon fontSize="small" />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEls[index]}
                      open={Boolean(anchorEls[index])}
                      onClose={closeFunc(index)}
                    >
                      {item.actions.map((action) => (
                        <React.Fragment key={action.title}>
                          {(action.condition === undefined || action.condition) && (
                            <MenuItem
                              onClick={() => {
                                closeFunc(index)()
                                action.onClick()
                              }}
                            >
                              {action.title}
                            </MenuItem>
                          )}
                        </React.Fragment>
                      ))}
                    </Menu>
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
          {obj.isLoading ? (
            <LinearProgress />
          ) : (
            <DetailTable obj={obj} fields={fields} customFields={customFields} />
          )}
        </Centered>
      </CardContent>
    </Card>
  )
}
